import { any, bool, func, string } from 'prop-types';
import React from 'react';
import { Button, Col, Form, Row } from 'reactstrap';

function SubmittableForm({ children, onSubmit, loading, className, id }) {
  return (
    <Form onSubmit={onSubmit} className={className} id={id}>
      {children}
      {onSubmit && (
        <Row>
          <Col>
            <div className="btn-group">
              <Button type="submit" disabled={loading} color="primary">
                Save
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
}

SubmittableForm.propTypes = {
  children: any, // eslint-disable-line react/forbid-prop-types
  onSubmit: func,
  className: string,
  id: string,
  loading: bool,
};

SubmittableForm.defaultProps = {
  children: '',
  onSubmit: undefined,
  className: '',
  id: '',
  loading: false,
};

export default SubmittableForm;
